class UniversalAccordion {
  constructor() {
    this.accordions = document.querySelectorAll("[data-accordion]");
    this.init();
  }

  init() {
    this.handleResize();
    window.addEventListener("resize", () => this.handleResize());
  }

  handleResize() {
    const currentWidth = window.innerWidth;

    this.accordions.forEach((container) => {
      const trigger = container.querySelector("[data-accordion-trigger]");
      const breakpoint = parseInt(container.dataset.accordion);

      if (!trigger) return;

      this.updateAccordionState(trigger, container);

      if (breakpoint === 0 || currentWidth < (breakpoint || 992)) {
        if (!container.dataset.accordionInitialized) {
          this.setupAccordionInstance(trigger, container);
          container.dataset.accordionInitialized = "true";
        }
      } else {
        delete container.dataset.accordionInitialized;
      }
    });
  }

  setupAccordionInstance(trigger, container) {
    const content = this.getAccordionContent(trigger);
    if (!content) return;

    trigger.setAttribute(
      "data-trigger-margin-bottom",
      getComputedStyle(trigger).marginBottom
    );
    trigger.style.marginBottom = "0px";
    trigger.style.transition = "margin-bottom 0.3s ease-out";

    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease-out";

    trigger.addEventListener("click", (e) => {
      const breakpoint = parseInt(container.dataset.accordion);
      if (breakpoint !== 0 && window.innerWidth >= (breakpoint || 992)) return;

      e.preventDefault();
      this.toggleAccordion(trigger, container);
    });

    this.updateAccordionState(trigger, container);
  }

  getAccordionContent(trigger) {
    const container = trigger.closest("[data-accordion]");
    const items = Array.from(container.children).filter(
      (child) => child !== trigger
    );

    if (items.length === 0) return null;

    let wrapper = container.querySelector("[data-accordion-content]");
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.setAttribute("data-accordion-content", "");
      items.forEach((item) => wrapper.appendChild(item));
      container.appendChild(wrapper);
    }

    return wrapper;
  }

  toggleAccordion(trigger, container) {
    const isActive = container.classList.contains("accordion-active");

    if (isActive) {
      this.closeAccordion(container);
    } else {
      this.accordions.forEach((otherContainer) => {
        if (otherContainer !== container) {
          this.closeAccordion(otherContainer);
        }
      });
      this.openAccordion(container);
    }
  }
  openAccordion(container) {
    const trigger = container.querySelector("[data-accordion-trigger]");
    if (!trigger) return;

    const content = this.getAccordionContent(trigger);
    const icon = trigger.querySelector("[data-accordion-icon]");

    content.style.height = "0px";
    requestAnimationFrame(() => {
      content.style.height = content.scrollHeight + "px";
    });
    container.classList.add("accordion-active");
    trigger.style.marginBottom = trigger.dataset.triggerMarginBottom || "0px";
    if (icon) icon.setAttribute("data-accordion-open", "true");

    setTimeout(() => {
      if (container.classList.contains("accordion-active")) {
        content.style.height = "auto";
      }
    }, 300);
  }
  closeAccordion(container) {
    if (!container.classList.contains("accordion-active")) {
      return;
    }

    const trigger = container.querySelector("[data-accordion-trigger]");
    if (!trigger) return;

    const content = this.getAccordionContent(trigger);
    const icon = trigger.querySelector("[data-accordion-icon]");

    content.style.height = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
    container.classList.remove("accordion-active");
    trigger.style.marginBottom = "0px";
    if (icon) icon.setAttribute("data-accordion-open", "false");
  }
  updateAccordionState(trigger, container) {
    const breakpoint = parseInt(container.dataset.accordion);
    const content = this.getAccordionContent(trigger);
    const icon = trigger.querySelector("[data-accordion-icon]");

    if (breakpoint !== 0 && window.innerWidth >= (breakpoint || 992)) {
      content.style.height = "auto";
      container.classList.remove("accordion-active");
      if (icon) icon.style.display = "none";
      trigger.style.cursor = "default";
    } else {
      if (icon) {
        icon.style.display = "block";
        icon.style.transition = "transform 0.3s ease-out";
      }
      trigger.style.cursor = "pointer";

      if (!container.classList.contains("accordion-active")) {
        content.style.height = "0px";
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new UniversalAccordion();
});
